<template>
  <div>
    <div ref="component" id="myChart"></div>
  </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  data() {
    this.isEchart = ""
    return {
      specialtyList: [],
    }
  },

  created() {},
  async mounted() {
    await this.getSpecialty()
  },
  methods: {
    getSpecialty() {
      request({
        url: "/sqyl/admin/volunteerArchive/info/goodAtCount",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code == 200) {
          this.specialtyList = [
            res.content.myGoodAt0,
            res.content.myGoodAt1,
            res.content.myGoodAt2,
            res.content.myGoodAt3,
            res.content.myGoodAt4,
            res.content.myGoodAt5,
          ]
          this.drawLine()
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },
    drawLine() {
      // let dataList = []
      // let xData = []
      // this.specialtyList.forEach((item,index) => {
      //     dataList.push(item.count)
      // if (item.goodAt == 0) {
      //     dataList.push(item.count)
      //     xData.push("书法")
      // } else if (item.goodAt == 1) {
      //     dataList.push(item.count)
      //     xData.push("绘画")
      // } else if (item.goodAt == 2) {
      //     dataList.push(item.count)
      //     xData.push("料理")
      // } else if (item.goodAt == 3) {
      //     dataList.push(item.count)
      //     xData.push("羽毛球")
      // } else if (item.goodAt == 4) {
      //     dataList.push(item.count)
      //     xData.push("兵乓球")
      // } else if (item.goodAt == 5) {
      //     dataList.push(item.count)
      //     xData.push("其他")
      // }
      // dataList.push(item.count)
      // })
      // 基于准备好的dom，初始化echarts实例
      this.isEchart = this.$echarts.init(document.getElementById("myChart"))
      this.$echarts.init(this.$refs.component, null, {
        renderer: "canvas",
      })
      // 绘制图表
      this.isEchart.setOption({
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["书法", "绘画", "料理", "羽毛球", "兵乓球", "其他"],
          axisLabel: {
            color: "#ffffff",
            fontSize: "10",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff",
            fontSize: "10",
          },
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#113d5e",
            },
          },
        },
        series: [
          {
            data: this.specialtyList,
            type: "line",
            itemStyle: {
              normal: {
                color: "#05b4f6",
              },
            },
          },
        ],
      })
    },
  },
  beforeDestroy() {
    if (this.isEchart) {
      this.isEchart.clear()
    }
  },
}
</script>

<style lang="less" scoped>
#myChart {
  width: 400px;
  height: 27vh;
}
</style>
